import React from 'react'
import { createSearchParams, useNavigate } from 'react-router-dom'
import { Formik, FormikProps } from 'formik'
import * as Yup from 'yup'

import { useParamsToObj } from '../../hooks/useParamsToObj'
import { ExperienceFilter } from '../../types/experiences'

import Drawer from '../Drawer'
import Spinner from '../Spinner'
import ExperienceFiltersForm from './ExperienceFiltersForm'

type FilterDrawerProps = {
  onClose: () => void
  open: boolean
  filter: ExperienceFilter
  setFilter: React.Dispatch<React.SetStateAction<ExperienceFilter>>
  resetFilter: () => void
}

const schema = Yup.object().shape({
  date_from: Yup.string(),
  date_to: Yup.string(),
  rating: Yup.array().of(Yup.string()),
  status: Yup.string().nullable(),
  customers: Yup.array().of(Yup.object()),
  locations: Yup.array().of(Yup.object()),
  areas: Yup.array().of(Yup.object()),
  usernames: Yup.array().of(Yup.object()),
})

const FilterDrawer: React.FC<FilterDrawerProps> = (props) => {
  const navigate = useNavigate()
  const urlParams = useParamsToObj(['search'])

  const handleOnSubmit = async (values: ExperienceFilter) => {
    try {
      const searchParams = createSearchParams()

      if (urlParams.search) {
        searchParams.append('search', urlParams.search)
      }

      navigate({
        search: `?${searchParams}`,
      })

      props.setFilter(values)
      props.onClose()
    } catch (e: any) {
      console.log('🚀 ~ file: Experiences/FilterDrawer.tsx ~ line 47 ~ handleOnSubmit ~ error', e)
    }
  }

  return (
    <Drawer open={props.open} onClose={props.onClose}>
      <Formik
        enableReinitialize
        initialValues={props.filter}
        validationSchema={schema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={handleOnSubmit}
      >
        {({ isSubmitting, dirty }: FormikProps<ExperienceFilter>) => (
          <Drawer.FormContainer
            open={props.open}
            onClose={props.onClose}
            title="Filters"
            Footer={
              <>
                <button
                  className="btn btn-white"
                  onClick={() => {
                    props.resetFilter()
                    props.onClose()
                  }}
                  disabled={isSubmitting}
                  type="button"
                >
                  Reset
                </button>

                <button className="btn btn-primary ml-4" type="submit" disabled={isSubmitting || !dirty}>
                  {isSubmitting ? (
                    <>
                      <Spinner className="h-5 w-5 text-gray-700" aria-hidden="true" />
                      Loading
                    </>
                  ) : (
                    'Apply'
                  )}
                </button>
              </>
            }
          >
            <ExperienceFiltersForm isSubmitting={isSubmitting} />
          </Drawer.FormContainer>
        )}
      </Formik>
    </Drawer>
  )
}

export default FilterDrawer
